import React from 'react';
import {Box, Container, Grid, Typography, useMediaQuery} from '@mui/material';
import {Outlet, useLocation, useNavigate} from 'react-router-dom';
import 'pages/FormPage.css';
import Button from '@mui/material/Button';
import {ReactComponent as LogoutIcon} from 'assets/icon-logout.svg';
import {logout} from 'lib/utils/loginUtils';
import T from 'i18n-react';
import fullSideBackgroundImage from 'assets/img.png';
import croppedSideBackgroundImage from 'assets/background_image_cropped.png';
import soleraBadge from 'assets/solera_brand.png';
import soleraGradient from 'assets/solera_gradient.png';
import brandInversed from 'assets/Brand_inversed.svg'

const FormPage = (props) => {

    const navigate = useNavigate();
    const location = useLocation();
    const isPortraitOrientation = useMediaQuery('(orientation: portrait)');
    const isTabletOrMobileLandscape = useMediaQuery('(orientation: landscape) and (min-width: 600px) and (max-width: 960px)');
    const sideBackgroundImage = useMediaQuery('(max-width: 1200px)') ? croppedSideBackgroundImage : fullSideBackgroundImage;
    const isTabletInPortraitOrientation = useMediaQuery('(orientation: portrait) and (min-width: 768px) and (min-height: 1024px)');

    const logoutHandler = () => {
        logout();
        navigate('/login');
    };

    const renderHeader = () => {
        return <div className="fourthContainer">
            <img className={'brandInversed'} src={brandInversed} alt={'brandInversed'} onClick={() => {
                if (location.pathname === '/request-password' || location.pathname.startsWith('/recover/')) navigate('/login');
            }} />
        </div>;
    };

    const renderBodyForPortrait = () => {
        return <Grid item className={'secondContainer'} xs={12} flexDirection='column'>
            {renderLogoutButton()}
            <Container className="thirdContainer">
                {renderHeader()}
                <Grid container paddingTop={isTabletInPortraitOrientation ? '15vh' : 0}>
                    <Grid item xs={2} sm={2}/>
                    <Grid item xs={8} sm={8} alignItems='center'>
                        <Outlet/>
                    </Grid>
                    <Grid item xs={2} sm={2}/>
                </Grid>
            </Container>
            <Grid container marginTop={isTabletInPortraitOrientation ? 'auto' : '10vh'}>
                <Grid item xs={1}/>
                <Grid item xs={11}>
                    <img src={soleraBadge} alt='soleraBadge'/>
                </Grid>
            </Grid>
            {isTabletInPortraitOrientation ?
                <Box position={"fixed"} bottom={0} right={0}>
                    <img src={soleraGradient} alt='soleraGradient'/>
                </Box>
                : ''}
        </Grid>
    };

    const renderLogoutButton = () => {
        return props.isLogoutButtonVisible ? <div className="logoutDiv">
                <Button className="vinFormLogoutButton" onClick={logoutHandler}><LogoutIcon/></Button>
                <Typography className="logoutText" onClick={logoutHandler}>{T.translate('headerComponent.logout')}</Typography>
            </div>
            : null;
    };

    const renderBody = () => {
        if (isPortraitOrientation) {
            return renderBodyForPortrait();
        } else if (!isPortraitOrientation && isTabletOrMobileLandscape) {
            return <>
                <Grid className="secondContainer" item xs={5} sm={5} md={5} lg={5} xl={5}>
                    {renderLogoutButton()}
                    <Container className="thirdContainer">
                        {renderHeader()}
                        <Outlet/>
                    </Container>
                </Grid>
                <Grid item xs={7} sm={7} md={7} lg={7} xl={7}
                      className='imageContainer'>
                    <img src={sideBackgroundImage} alt='sideBackgroundImage' className='image'/>
                </Grid>
            </>
        } else {
            return <>
                <Grid className="firstContainer" item xs={12} container>
                    <Grid className="secondContainer" item xs={6} sm={6} md={5} lg={4} xl={4}>
                        {renderLogoutButton()}
                        <Container className="thirdContainer">
                            {renderHeader()}
                            <Outlet/>
                        </Container>
                    </Grid>
                    <Grid item xs={6} sm={6} md={7} lg={8} xl={8}
                          className='imageContainer'>
                        <img src={sideBackgroundImage} alt='sideBackgroundImage' className='image'/>
                    </Grid>
                </Grid>
            </>
        }
    };

    return (
        <>
            {renderBody()}
        </>
    );
};

export default FormPage;
